import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeReportContentAdmin, getListReportsContent } from '../../actions/reportActions'
import ReportContentList from '../../containers/ReportContentList/ReportContentList'

const ReportedContent = () => {
    const dispatch = useDispatch()
    const {listOfReportsContent} = useSelector(state=>state.postAdmin)
    useEffect(() => {
      dispatch(getListReportsContent(3))
    
      return () => {
        
      }
    }, [])

    const changeReport = (status,id)=>{
      dispatch(changeReportContentAdmin(status,id))
    }
    
  return (
    <ReportContentList  changeReport={changeReport} listOfReports={listOfReportsContent}/>
  )
}

export default ReportedContent